export function batteryPercentage(mv) {
  if (mv == null) return null;
  return Math.min(100, Math.max(0, Math.round((mv - 2500) / 800 * 100)));
}
